"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchHighlight = void 0;
var SearchHighlight = /** @class */ (function () {
    function SearchHighlight(element) {
        this.matchRegex = null;
        this.root = element;
        this.query = this.getQueryFromUrl();
        this.terms = this.getTerms(this.query);
        if (this.terms.length === 0) {
            return;
        }
        this.matchRegex = this.buildMatchRegex();
        this.run();
    }
    SearchHighlight.prototype.getQueryFromUrl = function () {
        var _a, _b;
        var params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        return (_b = (_a = params.get('highlight')) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '';
    };
    SearchHighlight.prototype.getTerms = function (query) {
        var parts = query
            .split(/\s+/)
            .map(function (part) { return part.trim(); })
            .filter(Boolean);
        var uniqueParts = Array.from(new Set(parts));
        var filteredParts = uniqueParts.filter(function (part) { return part.length > 1; });
        if (filteredParts.length > 0) {
            return filteredParts.sort(function (left, right) { return right.length - left.length; });
        }
        return uniqueParts.length > 0 ? uniqueParts : [];
    };
    SearchHighlight.prototype.run = function () {
        var _this = this;
        var matchingNodes = this.findMatchingTextNodes();
        var expandablesToOpen = new Set();
        matchingNodes.forEach(function (node) {
            var expandableAncestors = _this.getExpandableAncestors(node);
            var highlighted = _this.highlightTextNode(node);
            if (highlighted) {
                expandableAncestors.forEach(function (expandable) { return expandablesToOpen.add(expandable); });
            }
        });
        this.openExpandables(expandablesToOpen);
    };
    SearchHighlight.prototype.findMatchingTextNodes = function () {
        var _this = this;
        var walker = document.createTreeWalker(this.root, NodeFilter.SHOW_TEXT, {
            acceptNode: function (node) {
                var _a;
                if (!((_a = node.textContent) === null || _a === void 0 ? void 0 : _a.trim())) {
                    return NodeFilter.FILTER_REJECT;
                }
                var parentElement = node.parentElement;
                if (!parentElement || _this.shouldSkipNode(parentElement)) {
                    return NodeFilter.FILTER_REJECT;
                }
                return _this.matches(node.textContent) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
            },
        });
        var nodes = [];
        var currentNode = walker.nextNode();
        while (currentNode) {
            nodes.push(currentNode);
            currentNode = walker.nextNode();
        }
        return nodes;
    };
    SearchHighlight.prototype.shouldSkipNode = function (element) {
        return Boolean(element.closest('script, style, noscript, textarea, template, mark, svg, oebb-search-inline, .search-inline__results'));
    };
    SearchHighlight.prototype.matches = function (value) {
        if (!this.matchRegex) {
            return false;
        }
        this.matchRegex.lastIndex = 0;
        return this.matchRegex.test(value);
    };
    SearchHighlight.prototype.highlightTextNode = function (node) {
        var _a;
        var text = node.textContent || '';
        if (!this.matchRegex) {
            return false;
        }
        var regex = this.matchRegex;
        regex.lastIndex = 0;
        if (!regex.test(text)) {
            return false;
        }
        regex.lastIndex = 0;
        var fragment = document.createDocumentFragment();
        var lastIndex = 0;
        text.replace(regex, function (_match, prefix, stem, suffix, offset) {
            var prefixStart = offset;
            var wordStart = prefixStart + prefix.length;
            var wordEnd = wordStart + stem.length + suffix.length;
            if (prefixStart > lastIndex) {
                fragment.appendChild(document.createTextNode(text.slice(lastIndex, prefixStart)));
            }
            if (prefix) {
                fragment.appendChild(document.createTextNode(prefix));
            }
            var mark = document.createElement('mark');
            mark.dataset.searchHighlight = 'true';
            mark.textContent = text.slice(wordStart, wordEnd);
            fragment.appendChild(mark);
            lastIndex = wordEnd;
            return _match;
        });
        if (lastIndex < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }
        (_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(fragment, node);
        return true;
    };
    SearchHighlight.prototype.buildMatchRegex = function () {
        var _this = this;
        // Match only at word start so "test" highlights "Tests" but not "Haltestellen".
        // The suffix also allows ":word" continuations so "senior" matches "Senior:innen".
        var wordChars = 'A-Za-z0-9À-ÖØ-öø-ÿ';
        return new RegExp("(^|[^".concat(wordChars, "])(").concat(this.terms.map(function (term) { return _this.escapeRegExp(term); }).join('|'), ")([").concat(wordChars, "]*(?::[").concat(wordChars, "]+)*)"), 'gi');
    };
    SearchHighlight.prototype.getExpandableAncestors = function (node) {
        var _a, _b;
        var ancestors = [];
        var currentElement = (_a = node.parentElement) === null || _a === void 0 ? void 0 : _a.closest('.js-expandable');
        while (currentElement) {
            ancestors.push(currentElement);
            currentElement = (_b = currentElement.parentElement) === null || _b === void 0 ? void 0 : _b.closest('.js-expandable');
        }
        return ancestors;
    };
    SearchHighlight.prototype.openExpandables = function (expandables) {
        var _this = this;
        Array.from(expandables)
            .sort(function (left, right) { return _this.getDepth(left) - _this.getDepth(right); })
            .forEach(function (expandable) { return _this.openExpandable(expandable); });
    };
    SearchHighlight.prototype.openExpandable = function (expandable) {
        var ref = expandable.ref;
        if (ref && typeof ref.setOpen === 'function') {
            ref.setOpen();
        }
    };
    SearchHighlight.prototype.getDepth = function (element) {
        var depth = 0;
        var currentElement = element.parentElement;
        while (currentElement) {
            depth += 1;
            currentElement = currentElement.parentElement;
        }
        return depth;
    };
    SearchHighlight.prototype.escapeRegExp = function (value) {
        return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };
    return SearchHighlight;
}());
exports.SearchHighlight = SearchHighlight;
